/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "If you choose to opt-in to emails from us, we’ll occasionally send you fun, informative content about our apps. Emails will usually only come once or twice a month and feature tips, suggestions, and relevant information that can improve your use of Timepage, Actions and Flow."), "\n", React.createElement(_components.p, null, "A subscription to our emails will also keep you informed about our updates. And of course, you can unsubscribe at any time."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
